<template>
  <div class="container mt-4">
    <!-- Filtros -->
    <div class="row g-2 mb-4 align-items-center">
      <div class="col-auto">
        <select v-model="filtro.tipo" class="form-select">
          <option value="diagnosticos">Diagnósticos</option>
          <option value="clasificacion">Clasificación detalle</option>
          <option value="codigos">Códigos detalle</option>
          <option value="nombres">Nombres detalle</option>
          <option value="total">Total planilla</option>
        </select>
      </div>
      <div class="col-auto" v-if="filtro.tipo !== 'total' && filtro.tipo !== 'clasificacion'">
        <input v-model="filtro.valor" type="text" placeholder="Ingrese búsqueda" class="form-control" />
      </div>
      <div class="col-auto" v-else-if="filtro.tipo === 'clasificacion'">
        <select v-model="filtro.valor" class="form-select">
          <option value="2">TPSNS</option>
          <option value="10">Medicamentos</option>
          <option value="11">Insumos</option>
        </select>
      </div>
      <div class="col-auto d-flex" v-else-if="filtro.tipo === 'total'">
        <input v-model="filtro.desde" type="number" placeholder="Desde" class="form-control me-2" />
        <input v-model="filtro.hasta" type="number" placeholder="Hasta" class="form-control" />
      </div>
      <div class="col-auto">
        <button @click="buscarPlanillas()" class="btn btn-primary">Buscar todos</button>
      </div>
      <div class="col-auto">
        <button @click="buscarPlanillas({ pendiente: true })" class="btn btn-primary">Buscar pendientes</button>
      </div>
      <div class="col-auto">
        <button @click="quitarFiltros()" class="btn btn-secondary">Quitar filtros</button>
      </div>
    </div>

    <!-- Botones exportación + selector registros por página -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-auto">
        <button @click="exportarEmpresaCSV" class="btn btn-success btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">download</span> Exportar CSV
        </button>
      </div>
      <div class="col-auto">
        <button @click="exportToExcel" class="btn btn-info btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">download</span> Exportar Excel
        </button>
      </div>
      <div class="col-auto" v-if="p_tipoConsulta === 'MANUALES'">
        <button @click="abrirCrear(0)" class="btn btn-primary btn-sm d-flex align-items-center gap-1">
          <span class="material-icons" style="font-size:16px">add</span> Registro
        </button>
      </div>
      <!-- Selector registros por página -->
      <div class="col-auto ms-auto d-flex align-items-center gap-2">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select v-model.number="registrosPorPagina" class="form-select form-select-sm"
          style="width:75px" @change="paginaActual = 1">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-sm align-middle">
        <thead class="table-dark">
          <tr>
            <th class="th-sort" @click="ordenarPor('numero')">
              Número <span>{{ iconOrden('numero') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('cedula')">
              Cédula <span>{{ iconOrden('cedula') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('nombre')">
              Nombre <span>{{ iconOrden('nombre') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('diagnosticos')">
              Diagnósticos <span>{{ iconOrden('diagnosticos') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('fechaDesde')">
              F. desde <span>{{ iconOrden('fechaDesde') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('fechaHasta')">
              F. hasta <span>{{ iconOrden('fechaHasta') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('totalPlanilla')">
              Total <span>{{ iconOrden('totalPlanilla') }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in itemsPaginaActual"
            :key="item.idPlanilla"
            @dblclick="abrirEditar(item.idPlanilla)"
            style="cursor: pointer;"
          >
            <td>{{ item.numero }}</td>
            <td>{{ item.cedula }}</td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.diagnosticos }}</td>
            <td>{{ getFormattedDate(item.fechaDesde) }}</td>
            <td>{{ getFormattedDate(item.fechaHasta) }}</td>
            <td class="text-end">{{ item.totalPlanilla }}</td>
          </tr>
          <tr v-if="itemsPaginaActual.length === 0">
            <td colspan="7" class="text-center text-muted py-4">No se encontraron resultados</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="7" class="text-end fw-bold small">
              Mostrando {{ desde }}–{{ hasta }} de {{ resultadosOrdenados.length }} atenciones
            </td>
          </tr>
        </tfoot>
      </table>

      <!-- Paginación -->
      <div class="d-flex justify-content-between align-items-center mt-3" v-if="resultados.length > 0">
        <span class="small text-muted">
          Página {{ paginaActual }} de {{ totalPaginas }} — {{ resultadosOrdenados.length }} registros
        </span>
        <nav aria-label="Paginación">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: paginaActual === 1 }">
              <a class="page-link" href="#" @click.prevent="irPrimeraPagina">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === 1 }">
              <a class="page-link" href="#" @click.prevent="paginaAnterior">‹</a>
            </li>
            <li
              v-for="pagina in paginasVisibles"
              :key="pagina"
              class="page-item"
              :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
            >
              <a class="page-link" href="#" @click.prevent="pagina !== '...' && cambiarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
              <a class="page-link" href="#" @click.prevent="paginaSiguiente">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
              <a class="page-link" href="#" @click.prevent="irUltimaPagina">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";

export default {
  name: "PlanillaConsulta",
  props: {
    p_tramite:      { type: Object, required: true },
    p_tipoConsulta: { type: String, required: true },
  },
  data() {
    return {
      p_idPerfil:  0,
      p_idUsuario: 0,
      filtro: {
        tipo:  "codigos",
        valor: "",
        desde: null,
        hasta: null,
      },
      pendiente:          false,
      resultados:         [],
      registrosPorPagina: 10,
      paginaActual:       1,
      // ── Ordenamiento ──────────────────────────────────────
      campoOrden: 'numero',
      ascendente: true,
    };
  },

  computed: {
    // ── Resultados ordenados ───────────────────────────────
    resultadosOrdenados() {
      const campo = this.campoOrden;
      return [...this.resultados].sort((a, b) => {
        let va = a[campo] ?? '';
        let vb = b[campo] ?? '';

        // Campo 'numero': ordenar como entero si es posible
        if (campo === 'numero') {
          const na = parseInt(va, 10);
          const nb = parseInt(vb, 10);
          if (!isNaN(na) && !isNaN(nb)) {
            return this.ascendente ? na - nb : nb - na;
          }
        }

        // Campo 'totalPlanilla': siempre numérico
        if (campo === 'totalPlanilla') {
          const na = parseFloat(va) || 0;
          const nb = parseFloat(vb) || 0;
          return this.ascendente ? na - nb : nb - na;
        }

        // Resto: comparación de texto
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },

    totalPaginas() {
      return Math.max(1, Math.ceil(this.resultadosOrdenados.length / this.registrosPorPagina));
    },

    itemsPaginaActual() {
      const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
      return this.resultadosOrdenados.slice(inicio, inicio + this.registrosPorPagina);
    },

    desde() {
      return this.resultados.length === 0
        ? 0
        : (this.paginaActual - 1) * this.registrosPorPagina + 1;
    },
    hasta() {
      return Math.min(this.paginaActual * this.registrosPorPagina, this.resultadosOrdenados.length);
    },

    // ── Páginas visibles con puntos suspensivos ────────────
    paginasVisibles() {
      const total  = this.totalPaginas;
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];

      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');

      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },

  watch: {
    'filtro.tipo'() {
      this.filtro.valor = '';
      this.filtro.desde = null;
      this.filtro.hasta = null;
    },
  },

  async mounted() {
    this.p_idPerfil  = window.sessionStorage.getItem("idPerfil")  || 0;
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario") || 0;
    const saved = sessionStorage.getItem("planillaFilters");
    if (saved && this.p_tipoConsulta === "FILTROS") {
      try {
        const filters = JSON.parse(saved);
        this.filtro = {
          tipo:  filters.tipo  || "codigos",
          valor: filters.valor || "",
          desde: filters.desde ? Number(filters.desde) : null,
          hasta: filters.hasta ? Number(filters.hasta) : null,
        };
        this.pendiente = !!filters.pendiente;
        await this.buscarPlanillas({ pendiente: this.pendiente });
      } catch (e) {
        console.error("Error al cargar filtros guardados", e);
      }
    }
  },

  methods: {
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.paginaActual = 1;
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },

    // ── Paginación ─────────────────────────────────────────
    irPrimeraPagina() { this.paginaActual = 1; },
    irUltimaPagina()  { this.paginaActual = this.totalPaginas; },
    paginaAnterior()  { if (this.paginaActual > 1) this.paginaActual--; },
    paginaSiguiente() { if (this.paginaActual < this.totalPaginas) this.paginaActual++; },
    cambiarPagina(n)  { if (n >= 1 && n <= this.totalPaginas) this.paginaActual = n; },

    // ── Búsqueda ───────────────────────────────────────────
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },

    async buscarPlanillas({ pendiente = false } = {}) {
      try {
        this.pendiente    = pendiente;
        this.paginaActual = 1;
        const params = new URLSearchParams();
        params.append("idTramite", this.p_tramite.idTramite);
        if (this.p_idPerfil === 18) params.append("usuarioMed", this.p_idUsuario);
        if (this.p_idPerfil === 20) params.append("usuarioDoc", this.p_idUsuario);
        switch (this.filtro.tipo) {
          case "diagnosticos":  params.append("diagnostico",   this.filtro.valor); break;
          case "clasificacion": params.append("clasificacion", this.filtro.valor); break;
          case "codigos":       params.append("codigo",        this.filtro.valor); break;
          case "nombres":       params.append("nombre",        this.filtro.valor); break;
          case "total":
            if (this.filtro.desde != null) params.append("desde", this.filtro.desde);
            if (this.filtro.hasta != null) params.append("hasta", this.filtro.hasta);
            break;
        }
        if (pendiente) {
          if ([17, 18].includes(Number(this.p_idPerfil))) params.append("estadoAud", "PENDIENTE");
          if ([19, 20].includes(Number(this.p_idPerfil))) params.append("estadoDoc", "PENDIENTE");
        }
        const { data } = await api.get(`/db-vwplanillas-resumen/buscar?${params.toString()}`);
        this.resultados = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error("Error al consultar planillas:", error);
        this.resultados = [];
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar las planillas" });
      }
    },
	
    refrescar() {
      this.buscarPlanillas({ pendiente: this.pendiente });
    },	

    quitarFiltros() {
      this.filtro    = { tipo: "codigos", valor: "", desde: null, hasta: null };
      this.pendiente = false;
      sessionStorage.removeItem("planillaFilters");
      this.buscarPlanillas();
    },

abrirEditar(idPlanilla) {
  if (!idPlanilla) return;

  sessionStorage.setItem(
    "planillaFilters",
    JSON.stringify({ ...this.filtro, pendiente: this.pendiente })
  );

  const params = new URLSearchParams({
    idTramite:     this.p_tramite.idTramite,
    idServicio:    this.p_tramite.idServicio,
    estadoTramite: this.p_tramite.estadoTramite,
    idPlanilla,
    tipoConsulta:  this.p_tipoConsulta,
  });

  window.open(`/planillaformpopup?${params.toString()}`, '_blank');
},

    abrirCrear() {
      Swal.fire("Info", "Función de creación aún no implementada", "info");
    },

    // ── Exportaciones ──────────────────────────────────────
    exportarEmpresaCSV() {
      if (!this.resultados.length) {
        Swal.fire("Advertencia", "No hay datos para exportar", "warning"); return;
      }
      const headers = ["ID Planilla","Número","Fecha de atención","Cédula","Nombre",
                       "Diagnósticos","Estado AM","Estado GD"];
      const content = [
        "\uFEFF" + headers.join(";"),
        ...this.resultadosOrdenados.map(r =>
          [r.idPlanilla,r.numero,r.fechaDesde,r.cedula,r.nombre,
           r.diagnosticos,r.estadoAud,r.estadoDoc]
          .map(v => `"${String(v ?? '').replace(/"/g, '""')}"`)
          .join(";")
        )
      ].join("\n");
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href     = URL.createObjectURL(blob);
      link.download = `consulta_atenciones_${this.p_tramite.idTramite}.csv`;
      link.style.display = "none";
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },

    exportToExcel() {
      if (!this.resultados.length) {
        Swal.fire("Advertencia", "No hay datos para exportar", "warning"); return;
      }
      const headers = ["ID Planilla","Número","Fecha de atención","Cédula","Nombre",
                       "Diagnósticos","Estado AM","Estado GD"];
      const data = this.resultadosOrdenados.map(r =>
        [r.idPlanilla,r.numero,r.fechaDesde,r.cedula,r.nombre,r.diagnosticos,r.estadoAud,r.estadoDoc]
      );
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Planillas");
      XLSX.writeFile(wb, `consulta_atenciones_${this.p_tramite.idTramite}.xlsx`);
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.pagination .page-link {
  cursor: pointer;
}
</style>